import { createStore } from 'zustand/vanilla';
import { hasAuthCookie } from '../../../storage/cookie';
import { StoredOffer } from '../kmx-thumb-offer-nav/types';
import { titleAsId, toggleChatFob } from '../utils';

export interface IMenuData {
    currentTitle?: string;
    isThumbNavMenuOpen?: boolean;
    thumbNavIndex?: number;
    isSignedIn: boolean;
    userId: string;
    validateUserCookie: () => void;
    activeTestVariant: string | undefined;
    reservationStockNumber?: string;
    onNavItemClick: ({ title }: { title: string; prevTitle: string | undefined }) => void;
    openThumbNav: () => void;
    closeThumbNav: (prevTitle: string | undefined) => void;
    setActiveTestVariant: (variant: string) => void;
    storedOffers: StoredOffer[];
}

export const navStore = createStore(
    (set): IMenuData => {
        return {
            currentTitle: undefined,
            isThumbNavMenuOpen: false,
            thumbNavIndex: undefined,
            isSignedIn: hasAuthCookie(),
            userId: '',
            validateUserCookie: async () => set({ userId: await getUserId() }),
            activeTestVariant: undefined,
            onNavItemClick: ({ title, prevTitle }) => {
                if (title !== prevTitle) {
                    set({
                        currentTitle: title,
                        isThumbNavMenuOpen: true
                    });
                } else {
                    set({
                        currentTitle: undefined,
                        isThumbNavMenuOpen: false
                    });
                }
            },
            openThumbNav: () => {
                set({ isThumbNavMenuOpen: true });
                toggleChatFob('hidden');
            },
            closeThumbNav: (prevTitle: string | undefined) => {
                set({ isThumbNavMenuOpen: false, currentTitle: undefined });
                toggleChatFob('visible');
                const firstNavBarItem = document.querySelector(
                    `#kmx-thumb-bar__item__button-${titleAsId(prevTitle!)}`
                ) as HTMLElement;
                firstNavBarItem.focus();
            },
            setActiveTestVariant: (variant: string) => {
                set({ activeTestVariant: variant });
            },
            storedOffers: []
        };
    }
);

const getUserId = async (): Promise<string> => {
    if (!hasAuthCookie()) {
        return Promise.resolve('');
    }

    const response = await fetch('/myaccount/token/svc/cookie/validate/low', {
        credentials: 'include'
    });
    const data = await response?.json();
    if (data.ciamId == null || data.expireTime == null) {
        return '';
    }
    const expireTime = new Date(data.expireTime);
    const currentDate = new Date();
    if (expireTime.getTime() > currentDate.getTime()) {
        return data.ciamId;
    }
    return '';
};
